import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./i18n/config";

import { routerBasename } from "./config/publicPath";
import { MaterialUIControllerProvider } from "./context";
import { ClientBrandingProvider } from "./providers/ClientBrandingProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false },
  },
});

// Legacy flag used in a few code paths; keep aligned with Vite's dev mode.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(globalThis as any).__DEV__ = import.meta.env.DEV;

// react-grid-layout / react-draggable reference `process.env` in the browser.
if (typeof (globalThis as { process?: unknown }).process === "undefined") {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).process = { env: { NODE_ENV: import.meta.env.MODE } };
}

const container = document.getElementById("app");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={routerBasename(import.meta.env.BASE_URL)}>
      <MaterialUIControllerProvider>
        <ClientBrandingProvider>
          <App />
        </ClientBrandingProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
